import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
/* empty css                   */
const ReorderButton = ({ url, tabIndex, ...rest }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("a", { href: url, className: "reorder-button header-menu__icon", tabIndex, ...rest }, getLabel("common.menu.reorder.button"));
};
export {
  ReorderButton as default
};
//# sourceMappingURL=ReorderButton.js.map
